import { errorAction } from './notifications';
import { throwErrorIfNotHandled } from './errorMiddleware';

export default function handleEntityUpdateConfirmationError(err, entityUpdateRequest, dispatch) {
    if (err.status === 409) {
        err.json().then((body) => {
            // The cross-table email-holding trigger returns a friendly `message`
            // string; per-column unique violations return an `errors[]` array.
            // Prefer the friendly message when present.
            if (body && typeof body.message === 'string' && body.message.length > 0) {
                dispatch(errorAction(`Failed to authorize entity update request - ${body.message}`));
            } else if (body && body.errors && body.errors[0]) {
                dispatch(errorAction(`Failed to authorize entity update request - ${body.errors[0].message}`));
            } else {
                dispatch(errorAction(`Failed to authorize entity update request ${entityUpdateRequest.id}`));
            }
        });
    } else {
        throwErrorIfNotHandled(`Failed to authorize entity update request ${entityUpdateRequest.id}`)(err);
    }
}
